export default `
    <link href='/snippets-style/footerHelp.css' rel='stylesheet' />
    <div class="footer-help">
      <div class="footer-help__title">HELP 24/7</div>
      <ul class="footer-help__list">
        <a href="mailto:suport@favbet.ro" rel="noreferrer"><img src="/images/snippetsMedia/contactsIcons/mail.svg" alt="Mail"></a>
        <a onclick="window.ShowSupport()"><img src="/images/snippetsMedia/contactsIcons/chat.svg" alt="Chat"></a>
        <a href="https://www.oki-toki.net/widget/?r=7775&lang=en" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/contactsIcons/support.svg" alt="Support"></a>
      </ul>
    </div>
`;
